//检查当前日期是单日还是双日
export function isOddOrEvenDay() {
  // 获取当前日期
  const currentDate = new Date();

  // 获取日数
  const day = currentDate.getDate();

  // 判断日数是单数还是双数
  if (day % 2 === 0) {
    return 1;
  } else {
    return 2;
  }
}



// WEBPACK FOOTER //
// ./src/utils/rules.js